module.exports = require('./helpers/bundle-url').getBundleURL('cG8j0') + "logo-dark.eefe0b7f.svg";